__turbopack_context__.v({
  "extensionText": "RenameDocumentDialog-module__lgRWda__extensionText",
});
